export const ThemeType = {
  Custom: 'custom',
  Theme_1177: '1177',
  Theme_1177_pro: '1177-pro',
  Inera_admin: 'Inera-admin'
} as const;
